<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <b-card header="Reset Your Password" header-tag="header" no-body>
            <b-card-body class="p-3">
              <h1 class="mx-auto d-block text-center mb-3">DigidoLMS</h1>
              <form @submit.prevent="reset">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><i class="icon-user"></i></div>
                  </div>
                  <input :class="{'form-control': true, 'is-invalid': errors.has('email')}"
                         v-validate="'required|email'"
                         data-vv-delay="500"
                         data-vv-as="Email"
                         data-vv-name="email"
                         type="email"
                         placeholder="Email"
                         name="email"
                         id="email"
                         autocomplete="email username"
                         v-model.trim="email"/>
                  <div class="invalid-tooltip d-block" v-if="errors.has('email')">{{ errors.first('email') }}</div>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><i class="icon-key"></i></div>
                  </div>
                  <input :class="{'form-control': true, 'is-invalid': errors.has('token')}"
                         v-validate="'required'"
                         data-vv-delay="500"
                         data-vv-as="token"
                         data-vv-name="token"
                         type="text"
                         placeholder="token"
                         name="token"
                         id="token"
                         readonly
                         autocomplete="token"
                         :value="token"/>
                  <div class="invalid-tooltip d-block" v-if="errors.has('token')">{{ errors.first('token') }}</div>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><i class="icon-lock"></i></div>
                  </div>
                  <input :class="{'form-control': true, 'is-invalid': errors.has('password')}"
                         v-validate="'required'"
                         data-vv-delay="500"
                         data-vv-as="password"
                         data-vv-name="password"
                         type="password"
                         placeholder="Password"
                         name="password"
                         id="password"
                         ref="password"
                         autocomplete="password"
                         v-model="password"/>
                  <div class="invalid-tooltip d-block" v-if="errors.has('password')">{{ errors.first('password') }}</div>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><i class="icon-lock"></i></div>
                  </div>
                  <input :class="{'form-control': true, 'is-invalid': errors.has('password_confirmation')}"
                         v-validate="'required|confirmed:password'"
                         data-vv-delay="500"
                         data-vv-as="Password"
                         data-vv-name="password"
                         type="password"
                         placeholder="Password Confirmation"
                         name="password_confirmation"
                         id="password_confirmation"
                         ref="password_confirmation"
                         autocomplete="password_confirmation username"
                         v-model="password_confirmation"/>
                  <div class="invalid-tooltip d-block" v-if="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</div>
                </div>
                <div class="input-group mb-3">
                  <loading-button variant="primary" block :loading="loading" @submit="reset">Reset Password</loading-button>
                </div>
              </form>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  data () {
    return {
      loading: false,
      email: '',
      password: '',
      password_confirmation: ''
    };
  },
  methods: {
    reset () {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true;
          this.axios.post('/auth/reset', {email: this.email, token: this.token, password: this.password, password_confirmation: this.password_confirmation}).then(() => {
            this.$swal('Success', 'You may now login!', 'success').then(() => {
              this.$router.push('/login');
            });

          }).catch(err => {
            this.$swal('Error', err.response.data.message, 'error');
            this.loading = false;
          });
        }
      });
    }
  },
  mounted () {
  },
  metaInfo: {
    title: 'Reset Password'
  },
  props: ['token']
};
</script>

<style lang="scss">
  .page-resetpassword {
    background: url("../../assets/img/login_bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    color: black;
  }
</style>